import React, { Component } from "react";

class SearchBar extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        return (
            <form class="form-inline my-2 my-lg-0">
                <span class="search-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17.999" viewBox="0 0 18 17.999">
                    <path id="search_Icon" data-name="search Icon" d="M9.583,2a7.579,7.579,0,1,0,4.644,13.56l4.159,4.155a.944.944,0,0,0,1.337.011.973.973,0,0,0,0-1.361L15.56,14.228A7.567,7.567,0,0,0,9.583,2Zm0,1.895A5.684,5.684,0,1,1,3.895,9.579,5.684,5.684,0,0,1,9.579,3.895Z" transform="translate(-2 -2)"/>
                </svg>

                </span>
                <input class="form-control mr-sm-2" type="search" placeholder="Search"
                    aria-label="Search" />
            </form>
        )
    }
}

export default SearchBar;